import React from "react";
import CustomCard from "../../../components/customCard/index";
import { lmtdCheck } from "../../../utils/common/index";

function RechargesalesDistrbution(props) {
  const {
    tableContainedData,
    csvEndPointUrl,
    isCsvActive,
    fetchCsvData,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    rechCsvLoading,
    moduleName,
    section,
  } = props;
  return (
    <>
      <div className="d-block d-sm-none col-12">
        <div
          id="carousel-div2"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carousel-div2"
              data-bs-slide-to="0"
              className="active"
            ></button>
            {tableContainedData.onBoarded !== null ? (
              <button
                type="button"
                data-bs-target="#carousel-div2"
                data-bs-slide-to="1"
              ></button>
            ) : null}
            {tableContainedData.percentageBilled !== null ? (
              <button
                type="button"
                data-bs-target="#carousel-div2"
                data-bs-slide-to="2"
              ></button>
            ) : null}
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <CustomCard
                tileName="Billed"
                csvName="Billed"
                lmtd={
                  lmtdCheck(headerSelectedDateFrom, headerSelectedDateTo)
                    ? tableContainedData.billedLMTD
                    : ""
                }
                value={tableContainedData.billed}
                csv={csvEndPointUrl}
                csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
                gradient="1"
                loading={rechCsvLoading}
                dashboardName={moduleName}
                viewName={section}
              />
            </div>
            <div className="carousel-item">
              {tableContainedData.onBoarded !== null ? (
                <CustomCard
                  tileName="On Boarded"
                  csvName="On Boarded"
                  value={tableContainedData.onBoarded}
                  csv={csvEndPointUrl}
                  csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
                  gradient="2"
                  loading={rechCsvLoading}
                  dashboardName={moduleName}
                  viewName={section}
                />
              ) : null}
            </div>
            <div className="carousel-item">
              {tableContainedData.percentageBilled !== null ? (
                <CustomCard
                  tileName="Percentage Billed"
                  value={tableContainedData.percentageBilled}
                  percentage={true}
                  gradient="3"
                  dashboardName={moduleName}
                  viewName={section}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className="d-none d-sm-block col-12">
        <div className="row">
          <CustomCard
            tileName="Billed"
            csvName="Billed"
            lmtd={
              lmtdCheck(headerSelectedDateFrom, headerSelectedDateTo)
                ? tableContainedData.billedLMTD
                : ""
            }
            value={tableContainedData.billed}
            csv={csvEndPointUrl}
            csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
            gradient="1"
            loading={rechCsvLoading}
            dashboardName={moduleName}
            viewName={section}
          />
          {tableContainedData.onBoarded !== null ? (
            <CustomCard
              tileName="On Boarded"
              csvName="On Boarded"
              value={tableContainedData.onBoarded}
              csv={csvEndPointUrl}
              csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
              gradient="2"
              loading={rechCsvLoading}
              dashboardName={moduleName}
              viewName={section}
            />
          ) : null}
          {tableContainedData.percentageBilled !== null ? (
            <CustomCard
              tileName="Percentage Billed"
              value={tableContainedData.percentageBilled}
              percentage={true}
              gradient="3"
              dashboardName={moduleName}
              viewName={section}
            />
          ) : null}
        </div>
      </div>
    </>
  );
}

export default RechargesalesDistrbution;
